var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg81(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 65.42 43.71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".g{fill:#00322e;}.h{fill:#fff;filter:url(#b);}.i{filter:url(#e);}"), /*#__PURE__*/React.createElement("filter", {
    id: "b",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "c",
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.18
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "c",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "e",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "f",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "f",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M30.29,37.95c-8.46,0-13.72-3.85-13.72-10.04,0-3.54,1.59-6.36,4.38-7.99-.9-1.29-1.38-2.89-1.38-4.68,0-6.19,5.46-10.04,14.24-10.04,3.03,0,12.92,.66,12.92,9.16,0,2.65-1.18,5-3.23,6.64,1.36,1.42,2.07,3.37,2.07,5.8,0,6.99-5.71,11.16-15.28,11.16Zm-.39-10.05s.2,.09,.67,.09c1.18,0,1.56-.38,1.56-1.56,0-.28-.06-.37-.06-.37-.03-.02-.23-.11-.66-.11-1.14,0-1.56,.43-1.56,1.6,0,.21,.03,.32,.05,.35h0Zm2.48-11.71s.11,0,.19,0c.71,0,1.12-.19,1.12-1.16v-.02c-.06-.01-.16-.02-.28-.02-.96,0-1.08,.12-1.08,1.08,0,.06,0,.1,.01,.12,0,0,.02,0,.04,0Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "d"
  }, /*#__PURE__*/React.createElement("g", {
    className: "i"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M43.57,26.79c0,6.4-5.76,9.16-13.28,9.16-6.88,0-11.72-2.72-11.72-8.04,0-3.68,2.08-6.48,6.24-7.32-2-.92-3.24-2.72-3.24-5.36,0-5.32,5.2-8.04,12.24-8.04s10.92,2.76,10.92,7.16c0,3.16-2.12,5.52-5.2,6.52,2.68,.88,4.04,2.84,4.04,5.92Zm-9.44-.36c0-1.64-1-2.48-2.72-2.48-2.24,0-3.56,1.32-3.56,3.6,0,1.64,1,2.44,2.72,2.44,2.4,0,3.56-1.4,3.56-3.56Zm1.56-11.4c0-1.28-.76-2.04-2.28-2.04-2.04,0-3.08,1-3.08,3.08,0,1.24,.8,2.12,2.24,2.12,2.04,0,3.12-1.32,3.12-3.16Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg81);
export default __webpack_public_path__ + "static/media/8_1.560f7d72dfd1d3603a8247bf1f31aebe.svg";
export { ForwardRef as ReactComponent };